import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { P2pChampionAndDonorSearchComponent } from 'app/manage-p2p/components/p2p-champion-and-donor-search/p2p-champion-and-donor-search.component';
import { P2pDetailsDonationsComponent } from 'app/manage-p2p/components/p2p-details-donations/p2p-details-donations.component';
import { P2pDonorDetailsComponent } from 'app/manage-p2p/components/p2p-donor-details/p2p-donor-details.component';
import { ModalP2pDetailService } from 'app/manage-p2p/services/modal-p2p-detail/modal-p2p-detail.service';
import * as _ from 'lodash';

@Component({
  standalone:true,
  selector: 'app-p2p-detail-modal',
  templateUrl: './p2p-detail-modal.component.html',
  styleUrl: './p2p-detail-modal.component.scss',
  imports:[CommonModule, P2pChampionAndDonorSearchComponent,P2pDetailsDonationsComponent,P2pDonorDetailsComponent]
})
export class P2pDetailModalComponent implements OnInit{

  @Input() data = null;

  public step: string = 'itemDetails';
  public prevStep: string = '';
  public placeOfCall: string = '';

  public selectedItem: any = null;
  public fundraiserData: any = null;
  public activeTab: string = '';
  
  constructor(
    private modalP2pDetailService: ModalP2pDetailService,
  ) {}

  ngOnInit() {
    this.placeOfCall = this.data.placeOfCall;
    this.step = this.placeOfCall;
    this.prevStep = this.placeOfCall;
    this.fundraiserData = this.data.fundraiserData;
    this.activeTab = this.data.activeTab || 'donations';
  }

  seeItemDetails(item) {
    this.prevStep = this.step;
    this.step = 'itemDetails';

    this.selectedItem = _.cloneDeep(item);
  }

  viewFundraiserDonations(fundraiser) {
    this.prevStep = this.step;
    this.step = 'viewDonations';

    this.fundraiserData = _.cloneDeep(fundraiser);
  }

  backToPrevStep() {
    this.step = this.prevStep;
  }

  backToSearch() {
    this.step = 'search';
  }

  close() {
    this.modalP2pDetailService.close();
  }
}
